<template>
    <div class="container q-mb-md buttons">
        <div class="row gutter-xs" :class="langAR">
            <div :class="{'col-xs-6 col-sm-6 col-md-2': !onSide, 'col-6': onSide}">
                <q-btn no-caps color="primary" v-close-overlay class="full-width super-hover"
                       :label="$T('share')" @click.prevent="showShare=true"></q-btn>
            </div>

            <div :class="{'col-xs-6 col-sm-6 col-md-2': !onSide, 'col-6': onSide}">
                <q-btn no-caps color="primary" v-close-overlay class="full-width super-hover"
                       :label="favourited?$T('remove favourite'):$T('add to favourite')"
                       @click="toggleFavourite()"></q-btn>
            </div>
            <div v-if="contentId && !noDownload" :class="{'col-xs-12 col-sm-12 col-md-2': !onSide, 'col-12': onSide}">
                <q-btn no-caps color="primary" v-close-overlay class="full-width super-hover"
                       :label="getBtnLabel(contentType)" @click="subscribe()"></q-btn>
            </div>
        </div>
        <q-modal v-model="showShare">
            <div class="layout-padding">

                <div class="modal-close">
                    <q-btn color="primary" round dense icon="close" @click="showShare = false"></q-btn>
                </div>

                <div class="q-py-lg">

                    <social-sharing @open="showShare=false"
                                    title="check it out this news"
                                    :quote="shareText"
                                    :description="shareText"
                                    hashtags="p4f,pocket4fun,g4m"
                                    :url="home"
                                    v-cloak inline-template>

                        <ul class="social_button">
                            <li>
                                <network network="facebook" id="facebook">
                                    <img src="../../../img/facobook_logo.png" alt="facebook" width="48" height="48"/>
                                </network>
                            </li>
                            <li>
                                <network network="googleplus" id="googleplus">
                                    <img src="../../../img/google_plus.png" alt="google+" width="48" height="48"/>
                                </network>
                            </li>

                            <li>
                                <network network="twitter" id="twitter">
                                    <img src="../../../img/twitter_icon.svg" width="48" height="48"/>
                                </network>
                            </li>

                            <li>
                                <network network="sms">
                                    <img src="../../../img/sms.png" alt="whatsapp" width="48" height="48"/>
                                </network>
                            </li>
                            <li>
                                <network network="email">
                                    <img src="../../../img/mail.png" alt="mail" width="48" height="48"/>
                                </network>
                            </li>
                            <li>
                                <network network="whatsapp">
                                    <img src="../../../img/whatsapp.png" alt="whatsapp" width="48" height="48"/>
                                </network>
                            </li>

                        </ul>

                    </social-sharing>

                </div>
            </div>
        </q-modal>
    </div>
</template>
<style lang="stylus" scoped>

    ul.social_button {
        padding: 0;
    }

    ul.social_button li {
        display: inline;
        margin-right: 20px;
        cursor: pointer;
    }
    .align{
        margin-top 50px
        margin-right -50%
        margin-left 75%
        @media (max-width 768px){
            margin-right 0%
            margin-left 0%
        }
    }
    .alignTop{
        margin-top 50px
    }
    .alignVideos{
        margin-top 50px
        margin-right -50%
        margin-left 55%
        @media (max-width 768px){
            margin-right 0%
            margin-left 0%
        }
    }
</style>
<script>
    import {
        QBtn,
        QIcon,
        QModal,
        Cookies,
    } from 'quasar-framework'
    import {mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: 'VButtons',
        props: {
            contentId: Number,
            onSide: Boolean,
            noDownload: Boolean,
            ios: Boolean,
            contentType: String,
            item: {
                type: Array,
                required: true
            },
            downloadLink: {
                type: String,
                required: false
            }
        },
        components: {
            QBtn,
            QIcon,
            QModal,
        },
        data: () => ({
            favourited: false,
            subscribed: false,
            showShare: false,
            home: `${config.appUrl}/`,
            shareText: "",
            lang: window.config.locale.toUpperCase(),
            langAR: '',
            portal_base: null,
        }),
        computed: {
            ...mapGetters({
                user: 'auth/user',
            })

        },
        methods: {
            subscribe() {
                if (!this.user)
                    this.$login(this.$route.path.replace("/", "").replace("/", "*"));
                else {
                    this.$watchUser('item', this.item, true)
                    axios.get(`${config.appUrl}/${this.portal_base}/${this.user.id}/subscription/${this.contentType}/${this.contentId}`)
                        .then(({data}) => {
                            window.location.href = data;
                        })
                        .catch(error => {
                            if (error.response && error.response.status == 404)
                                router.replace('/404')
                            this.$loading(false)
                        })
                }
            },
            getBtnLabel(contentType){
                switch (contentType) {
                    case "game":
                        return this.$T('play')
                        break;
                    case "video":
                        return this.$T('play video')
                        break;
                    case "music":
                        if(this.ios)
                            return this.$T('play music')
                        else
                            return this.$T('download')
                        break;
                    default:
                        return this.$T('download')
                        break;
                }
            },
            getShareText() {
                axios.get(`${config.appUrl}/${this.portal_base}/social-message`)
                    .then(({data}) => {
                        this.shareText = data.share_text;
                    })
                    .catch(error => {
                    })
            },
            toggleFavourite() {
                if (!this.user)
                    this.$login(this.$route.path.replace("/", "").replace("/", "*"));
                else
                    axios.post(`${config.appUrl}/${this.portal_base}/${this.user.id}/favourite/${this.contentType}/${this.contentId}/save`, {user: this.user})
                        .then(({data}) => {
                            this.favourited = data.favourited
                        })
                        .catch(error => {

                        })
            },
            checkState() {
                axios.get(`${config.appUrl}/${this.portal_base}/${this.contentType}/${this.contentId}/check`)
                    .then(({data}) => {
                        this.subscribed = data.subscribed;
                        this.favourited = data.favourite;
                    })
                    .catch(error => {
                    })
            },
            getLang(){
                if (this.lang === 'AR'){
                    if((window.location.href.split('/')[3] === 'sports') || (window.location.href.split('/')[3] === 'widgets'))
                        this.langAR = 'align'
                    else if (window.location.href.split('/')[3] === 'videos'){
                        this.langAR = 'alignVideos'
                    }else
                        this.langAR = 'alignTop'
                }else{
                    this.langAR = ''
                }
            }

        },
        mounted() {
            this.portal_base = Cookies.get('portal')
            //this.checkState()
            this.getShareText()
            this.$loginCallback()
            this.getLang()
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Buttons.vue